// history.js
import { createBrowserHistory } from "history";

const history = createBrowserHistory();
/**
 * The util return history object to be used in the entire app (with this method history obj is the same in all pages)
 */
export default history;
